












































































































































































































































































































































import { Vue, Component } from 'vue-property-decorator'
import {
  IPrivateSignature,
  getSignatureArea,
  setSignature,
  deleteUdid
} from '@/api/developer/developer-private/private'
import { getSignatureList, getSignatureTaskStatus, getSignatureStatus, reSign, batchReSign, getSignatureServerCode } from '@/api/developer/developer-private/company'
import { exportJson2Excel } from '@/utils/excel'
import {
  formatJson,
  resetObjValue2NoneString,
  formatTime,
  deepCopy
} from '@/utils/tool'
import { mixins } from 'vue-class-component'
import DateOption from '@/mixins/dateOption'

@Component({
  name: 'DeveloperPirvateSignature'
})
export default class extends mixins(DateOption) {
  // api data
  private params = {
    id: '',
    appName: '',
    appId: '',
    account: '',
    info: '',
    ovhAddr: '',
    ovhStatus: '',
    accountName: '',
    status: '',
    signArea: '',
    createDateStart: '',
    createDateEnd: '',
    page: 1,
    pageCount: 20
  }
  // component data
  tableLoading = false
  tableHeight: number = 500
  rawTableLength: number = 0
  loadingText = ''
  private tableData: any[] = []
  private tabData: any[] = []
  private statusList: any = {}
  private serverCodeList: any = []
  private taskStatusList: any = {}
  private areaList: any[] = []
  private selectedData: any[] = []
  private uncheckedData: any[] = []
  private dateArray: string[] = ['', '']
  private totalCount = 0
  private invalid = ['等待签名', '签署中']
  routeQuery: any = { id: 0, platform: 'ios' }
  private nodeList: number[] = [0]
  private reverse: Boolean = false
  // lifecycle
  async created() {
    this.tableLoading = true
    this.getSignatureStatus()
    this.getAreaList()
    this.getTableData()
    this.getSignatureServerCode()
    this.getSignatureTaskStatus()
  }
  mounted() {
    this.$nextTick(() => {
      this.setTableHeight()
      window.addEventListener('resize', this.setTableHeight)
    })
  }
  beforeDestroy() {
    window.removeEventListener('resize', this.setTableHeight)
  }
  // methods
  async getTableData() {
    try {
      this.nodeList = [0]
      let res: any = await getSignatureList(this.params)
      let tableData = res.data.dataList
      this.tabData = res.data.dataList
      if (tableData) {
        let list = [...(tableData || [])]
        let empArr: any[] = []
        let tid = 0
        list.forEach(item => {
          let obj = {
            ...(item || {})
          }
          if (item.ovhTaskList) {
            item.ovhTaskList.forEach((_item: any) => {
              let _obj = { ...(obj || {}) }
              for (let attr in _item) {
                _obj[attr] = obj[attr] || _item[attr]
              }
              tid++
              empArr.push(_obj)
            })
            this.nodeList.push(tid)
          } else {
            tid++
            empArr.push(obj)
            this.nodeList.push(tid)
          }
        })
        this.tableData = empArr
        this.rawTableLength = list.length
      } else {
        this.tableData = []
        return false
      }
      this.totalCount = res.data.pageInfo.totalCount
    } catch (error) {
      this.$message.error(error as string)
    } finally {
      this.tableLoading = false
    }
  }
  async getSignatureStatus() {
    let res: any = await getSignatureStatus()
    this.statusList = res.data
  }
  async getSignatureServerCode() {
    let res: any = await getSignatureServerCode()
    this.serverCodeList = res.data
  }
  async getSignatureTaskStatus() {
    let res: any = await getSignatureTaskStatus()
    this.taskStatusList = res.data
  }
  async handleExcel() {
    // let excelParams = deepCopy(this.params)
    this.loadingText = '正在拼命加载...'
    this.tableLoading = true
    try {
    //   let res: any = await getSignatureList(
    //     Object.assign(excelParams, {
    //       page: 1,
    //       pageCount: 100000
    //     })
    //   )
    //   if (res.status.code === 0) {
    //     setTimeout(() => {
    //       this['$message'].success('导出成功!')
    //     }, 200)
    //   } else {
    //     this['$message'].error('导出失败!')
    //     return
    //   }
      const filterVal: string[] = [
        'appId',
        'appName',
        'accountName',
        'status',
        'serverArea',
        'serverCode',
        'filePath',
        'info',
        'createDate'
      ]
      const theader: string[] = [
        '应用ID',
        '应用名称',
        '证书',
        '状态',
        '签名地区',
        '服务器',
        'IPA文件',
        '失败信息',
        '创建时间'
      ]
      if (this.tableData.length <= 0) {
        return this.$message.warning('请选择数据')
      }
      const list = this.tableData
      const data = formatJson(filterVal, list)
      exportJson2Excel(theader, data)
      this['$message'].success('导出成功!')
      ;(this.$refs['multiTable'] as any).clearSelection()
    } catch (error) {
      this['$message'].error(error as string)
    } finally {
      this.tableLoading = false
      this.loadingText = ''
    }
  }
  async getAreaList() {
    let res: any = await getSignatureArea()
    this.areaList = res.data.dataList
  }
  setTableHeight() {
    const filter: any = this.$refs.filter
    if (!filter) {
      return false
    }
    const filterDom: any = filter.$el
    this.tableHeight = document.body.clientHeight - 250 - filterDom.clientHeight
  }
  handleDateChange(date: string[]) {
    this.params.createDateStart = date && date[0]
    this.params.createDateEnd = date && date[1]
  }
  handleSearch() {
    if (this.tableLoading) { return false }
    let params:any = { ...this.params }
    for (let i in params) {
      if (typeof params[i] === 'string') {
        params[i] = (params[i] || '').trim()
      }
    }
    // if (!this.checkParams) return false
    this.params = params
    this.params.page = 1
    this.getTableData()
  }
  handleReset() {
    resetObjValue2NoneString(this.params, ['page', 'pageCount'])
    this.params.page = 1
    this.dateArray = ['', '']
    this.getTableData()
  }
  handleSelectionChange(list: any[]) {
    // console.log(list)
    let ids = list.map(item => item.appId)
    ids = Array.from(new Set(ids))
    // console.log(ids)
    if (list.length > 0) {
      this.selectedData = this.tabData.filter(item => ids.includes(item.appId))
    } else {
      this.selectedData = []
    }
  }
  async reSign() {
    let arr
    if (this.uncheckedData.length) {
      let ids = this.uncheckedData.map(item => item.id)
      let ar = this.tabData.filter(item => !ids.includes(item.id))
      arr = ar.map(item => item.appId)
    } else {
      arr = this.selectedData.map(item => item.appId)
    }
    // console.log(arr.map(item => item.appId).join(','))
    // console.log(arr)
    let res: any = await batchReSign({
      appId: arr.join(',')
    })
    if (res.status.code === 0) {
      this['$message'].success('批量重签成功')
    } else {
      this['$message'].error('批量重签失败')
    }
  }
  handleSelectAll() {
    // 如果没有选择全部, 则寻找未选择的行, 并将这些行选中
    if (this.selectedData.length < this.rawTableLength) {
      let tempSelectList = this.selectedData.map(item => item.appId)
      let unSelected: any[] = this.tableData.filter((item: any) => !tempSelectList.includes(item.appId))
      unSelected.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }
  handleSelectReverse() {
    this.selectedData = []
    let tempList: number[] = []
    let tempSelectList: number[] = []
    let indexList: number[] = []
    tempList = this.tableData.map(item => item.appId)
    tempSelectList = this.selectedData.map(item => item.appId)
    indexList = tempList.filter(item => !tempSelectList.includes(item))
    this.tableData.forEach(item => {
      if (indexList.includes(item.appId)) this.selectedData.push(item)
    })
    if (this.selectedData.length) {
      this.selectedData.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }
  async handleDeleteUdid(item: IPrivateSignature) {
    const { serverArea: area, udid } = item
    let res: any = await deleteUdid({
      clearParam: [{ area, udid }]
    })
    if (res.status.code === 0) {
      this['$message'].success('清除成功')
    } else {
      this['$message'].error('清除失败')
    }
  }
  async revive(item: any) {
    // console.log(item)
    this.tableLoading = true
    let res: any = await reSign(item.appId.toString())
    if (res.status.code === 0) {
      this['$message'].success('重签成功')
    } else {
      this['$message'].error('重签失败')
    }
    this.tableLoading = false
  }
  goToDetail(item: any) {
    this.routeQuery.id = item.appId
    this['$router'].push({
      name: 'AppDetail',
      query: this.routeQuery
    })
  }
  objectSpanMethod({ row, column, rowIndex, columnIndex }: any) {
    let nodeList = this.nodeList
    if (columnIndex < 9 || columnIndex === 11) {
      if (nodeList.indexOf(rowIndex) > -1) {
        let index = nodeList.indexOf(rowIndex)
        return {
          rowspan: nodeList[index + 1] - nodeList[index],
          colspan: 1
        }
      } else {
        return {
          rowspan: 0,
          colspan: 0
        }
      }
    }
  }

  // computed
  get showMultiSelect() {
    return this.selectedData.length > 1
  }
  get selectCount() {
    if (this.uncheckedData.length) {
      return this.tabData.length - this.uncheckedData.length
    } else {
      return this.selectedData.length
    }
  }
  get selectIds() {
    let t: number[] = []
    this.selectedData.forEach(item => {
      t.push(item.id)
    })
    let ids = t.join(',')
    return ids
  }
  get loading() {
    return this.tableLoading
  }
  get checkParams() {
    let { appName, appId, account, status, ovhStatus, ovhAddr } = this.params
    let arr = [...this.dateArray]
    return appName || appId || account || status || (arr[0] && arr[1])
  }
}
